// removed by extract-text-webpack-plugin
module.exports = {"BreakpointFromMedium":"(min-width: 640px)","mainText":"Gf977fb"};